import { UserRestriction } from '@/models/user-restriction';
import {
  UserRestrictionsActions,
  SetUserRestrictionsPayload,
  SetUnreachableRestrictionPayload,
  UnsetUserRestrictionsPayload,
} from './props';
import { Nullable } from '@starsoft/common/interfaces';
import { Restriction } from '@/models/restriction';

export function setUserRestrictions(
  userRestriction: Nullable<UserRestriction>,
): SetUserRestrictionsPayload {
  return { type: UserRestrictionsActions.Set, payload: userRestriction };
}

export function setUnreachableRestriction(
  restriction: Nullable<Restriction>,
): SetUnreachableRestrictionPayload {
  return {
    type: UserRestrictionsActions.SetUnreachableRestriction,
    payload: restriction,
  };
}

export function unsetUserRestrictions(): UnsetUserRestrictionsPayload {
  return { type: UserRestrictionsActions.Unset, payload: null };
}
